import { NgModule } from "@angular/core";
import { LookupsModule } from "../lookups/lookups.module";
import { EOtpremniceRoutingModule } from "./eotpremnice-routing.module";
import { TranslateModule } from '@ngx-translate/core';
import { ModalContainerService, ModalService } from 'yt-ng-framework';
import { EOtpremnicaService } from "./eotpremnica/eotpremnica-service";
import { HomeComponent } from './home/home.component';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { EOtpremnicaComponent } from "./eotpremnice.component";
import { EOtpremnicaTabsComponent } from "./eotpremnica/eotpremnica-tabs.component";
import { EOtpremnicaTabUpdateComponent } from "./eotpremnica/eotpremnica-tab-update.component";
import { EOtpremnicaView } from "./eotpremnica/eotpremnica-view";
import { EOtpremnicaStavka } from "./eotpremnica/eotpremnica-stavka";
import { EOtpremnicaStavkaView } from "./eotpremnica/eotpremnica-stavka-view";
import { EOtpremnicaUpdateComponent } from './eotpremnica/eotpremnica-update.component';
import { EOtpremniceFilterComponent } from "./_filters/eotpremnice-filter.component";
import { EOtpremnicaStavkaUpdateContainer} from "./eotpremnica/eotpremnica-stavka-update-container.component";
import { EOtpremnicaStavkaInlineUpdateComponent} from './eotpremnica/eotpremnica-stavka-inline-update.component';
import { EOtpremnicaStavkaModalUpdateComponent } from "./eotpremnica/eotpremnica-stavka-modal-update.component";
import { EOtpremnicaStavkaUpdateComponent } from "./eotpremnica/eotpremnica-stavka-update.component";
import { EPrijemnicaTabsComponent } from "./eprijemnica/eprijemnica-tabs.component";
import { EPrijemnicaTabUpdateComponent } from "./eprijemnica/eprijemnica-tab-update.component";
import { EPrijemnicaStavka } from "./eprijemnica/eprijemnica-stavka";
import { EPrijemnicaStavkaUpdateComponent } from "./eprijemnica/eprijemnica-stavka-update.component";
import { EPrijemnicaUpdateComponent } from "./eprijemnica/eprijemnica-update.component";
import { NacinOtpremeComponent } from "./nacin-otpreme/nacin-otpreme.component";
import { TipOtpremnice } from "./tip-otpremnice/tip-otpremnice";
import { TipOtpremniceComponent } from "./tip-otpremnice/tip-otpremnice.component";
import { EOtpremnicaPrevozInlineUpdateComponent } from "./eotpremnica/eotpremnica-prevoz-inline-update.component";
import { EOtpremnicaPrevozUpdateContainer } from "./eotpremnica/eotpremnica-prevoz-update-container.component";
import { EOtpremnicaPrevozUpdateComponent } from "./eotpremnica/eotpremnica-prevoz-update.component";
import { EOtpremnicaStavkaDodatniAtributUpdateComponent } from "./eotpremnica/eotpremnica-stavka-dodatni-atribut-update.component";
import { EOtpremnicaStavkaDodatniAtributUpdateContainer } from "./eotpremnica/eotpremnica-stavka-dodatni-atribut-update-container.component";
import { EOtpremnicaStavkaDodatniAtributInlineUpdateComponent } from "./eotpremnica/eotpremnica-stavka-dodatni-atribut-inline-update.component";
import { EPrijemnicaStavkaInlineUpdateComponent } from "./eprijemnica/eprijemnica-stavka-inline-update.component";
import { EPrijemnicaStavkaUpdateContainer } from "./eprijemnica/eprijemnica-stavka-update-container.component";
import { EOtpremnicaOpasnaMaterijaUpdateContainer } from "./eotpremnica/eotpremnica-opasna-materija-update-container.component";
import { EOtpremnicaOpasnaMaterijaUpdateComponent } from "./eotpremnica/eotpremnica-opasna-materija-update.component";
import { EOtpremnicaOpasnaMaterijaInlineUpdateComponent } from "./eotpremnica/eotpremnica-opasna-materija-inline-update.component";
import { EPrijemnicaService } from "./eprijemnica/eprijemnica-service";
import { EPrijemnicaOpasnaMaterijaUpdateContainer } from "./eprijemnica/eprijemnica-opasna-materija-update-container.component";
import { EPrijemnicaOpasnaMaterijaUpdateComponent } from "./eprijemnica/eprijemnica-opasna-materija-update.component";
import { EPrijemnicaOpasnaMaterijaInlineUpdateComponent } from "./eprijemnica/eprijemnica-opasna-materija-inline-update.component";
import { EPrijemnicaStavkaDodatniAtributUpdateComponent } from "./eprijemnica/eprijemnica-stavka-dodatni-atribut-update.component";
import { EPrijemnicaStavkaDodatniAtributUpdateContainer } from "./eprijemnica/eprijemnica-stavka-dodatni-atribut-update-container.component";
import { EPrijemnicaStavkaDodatniAtributInlineUpdateComponent } from "./eprijemnica/eprijemnica-stavka-dodatni-atribut-inline-update.component";
import { EPrijemnicaPrevozInlineUpdateComponent } from "./eprijemnica/eprijemnica-prevoz-inline-update.component";
import { EPrijemnicaPrevozUpdateComponent } from "./eprijemnica/eprijemnica-prevoz-update.component";
import { EPrijemnicaPrevozUpdateContainer } from "./eprijemnica/eprijemnica-prevoz-update-container.component";
import { SendEdokumentComponent } from "./edokument/send-edokument.component";
import { PocetakVoznjeComponent } from "./edokument/pocetak-voznje.component";
import { PromenaVozilaComponent } from "./edokument/promena-vozila.component";
import { EPrijemnicaStavkaModalUpdateComponent } from "./eprijemnica/eprijemnica-stavka-modal-update.component";

@NgModule({
    imports:[ 
        // CommonModule,
        // FormsModule,
        // ReactiveFormsModule,
        EOtpremniceRoutingModule,
        LookupsModule,
        NgbModule,
        TranslateModule.forChild()
    ],
    declarations:[HomeComponent,
        EOtpremnicaComponent,
        EOtpremnicaTabsComponent,
        EOtpremnicaTabUpdateComponent,
        EOtpremnicaUpdateComponent,
        EOtpremniceFilterComponent,
        EOtpremnicaStavkaUpdateContainer,
        EOtpremnicaStavkaInlineUpdateComponent,
        EOtpremnicaStavkaModalUpdateComponent,
        EOtpremnicaStavkaUpdateComponent
        , EPrijemnicaTabsComponent
        , EPrijemnicaTabUpdateComponent
        , EPrijemnicaUpdateComponent
        , EPrijemnicaStavkaUpdateComponent
        , EPrijemnicaStavkaInlineUpdateComponent
        , EPrijemnicaStavkaUpdateContainer
        , NacinOtpremeComponent
        , TipOtpremniceComponent
        , EOtpremnicaPrevozUpdateContainer
        , EOtpremnicaPrevozUpdateComponent
        , EOtpremnicaPrevozInlineUpdateComponent        
        , EOtpremnicaStavkaDodatniAtributUpdateContainer
        , EOtpremnicaStavkaDodatniAtributInlineUpdateComponent
        , EOtpremnicaStavkaDodatniAtributUpdateComponent
        , EOtpremnicaOpasnaMaterijaUpdateContainer
        , EOtpremnicaOpasnaMaterijaInlineUpdateComponent
        , EOtpremnicaOpasnaMaterijaUpdateComponent
        , EPrijemnicaOpasnaMaterijaUpdateContainer
        , EPrijemnicaOpasnaMaterijaInlineUpdateComponent
        , EPrijemnicaOpasnaMaterijaUpdateComponent
        , EPrijemnicaStavkaDodatniAtributUpdateContainer
        , EPrijemnicaStavkaDodatniAtributInlineUpdateComponent
        , EPrijemnicaStavkaDodatniAtributUpdateComponent
        , EPrijemnicaPrevozUpdateContainer
        , EPrijemnicaPrevozUpdateComponent
        , EPrijemnicaPrevozInlineUpdateComponent  
        , SendEdokumentComponent     
        , PocetakVoznjeComponent 
        , PromenaVozilaComponent
        , EPrijemnicaStavkaModalUpdateComponent
    ],
    exports:[
        EOtpremniceFilterComponent
        , EOtpremnicaTabsComponent
        , EOtpremnicaUpdateComponent
        , EOtpremnicaStavkaUpdateComponent
        , EOtpremnicaPrevozUpdateComponent
        , EOtpremnicaOpasnaMaterijaUpdateComponent
        , EOtpremnicaStavkaDodatniAtributUpdateComponent
        , EPrijemnicaTabsComponent
        , EPrijemnicaUpdateComponent
        , EPrijemnicaStavkaUpdateComponent
        , EPrijemnicaStavkaDodatniAtributUpdateComponent
    ],
    providers:[
        ModalContainerService,
        ModalService,
        EOtpremnicaService
        , EPrijemnicaService
    ]
})

export class EOtpremnicaModule {}
